import {Page} from '@blesk-frontend/ui';
import {GuideListTopbar} from '@/features/guides';

interface AppPageWrapperProps {
  children: React.ReactNode;
}
export const AppPageWrapper = ({children}: AppPageWrapperProps) => {
  return (
    <Page className="flex h-full flex-col">
      <GuideListTopbar />
      <div className="container mx-auto flex size-full w-full max-w-screen-xl flex-col items-center justify-center gap-6 rounded-lg border bg-bg-secondary p-8">
        {children}
      </div>
    </Page>
  );
};
